'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _InlineSummaryEditor = require('./components/InlineSummaryEditor');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InlineSummaryEditor).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-ugc-editors/lib/components/inline-summary-editor/index.js
// module id = 1521
// module chunks = 1